import { render, staticRenderFns } from "./AttachmentForm.vue?vue&type=template&id=c9f5d750&scoped=true&"
import script from "./AttachmentForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentForm.vue?vue&type=style&index=0&id=c9f5d750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f5d750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VContainer,VForm,VRow,VTextField})
